
import React from "react";
import axios from "axios";
import { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, Tooltip, ResponsiveContainer, Cell, PieChart, Pie, Legend } from "recharts";
import { API_URL } from "../config";

function Reports() {
  const [booking, setBooking] = useState([]);
  useEffect(() => { fetchBooking(); }, []);
  const fetchBooking = async () => {
    try {
      const res = await axios.get(`${API_URL}/booking`);
      setBooking(res.data);
    }
    catch (err) {
      console.error("error", err);
    }
  };
  
  const tripcount = {};
  booking.forEach((book) => {
    const name = book.tribname;
    tripcount[name] = (tripcount[name] || 0) + 1;
  });
  const chatData = Object.entries(tripcount).map(([name, count]) => ({
    name, count,
  }));

  // Marine Services Stats
  const [stats, setStats] = useState([]);
  useEffect(() => {
    const fetchServeic = async () => {
      try {
        const supply = await axios.get(`${API_URL}/shipSupply`);
        const husbandry = await axios.get(`${API_URL}/ShipHusbandry`);
        const civil = await axios.get(`${API_URL}/CivilWork`);
        const offshore = await axios.get(`${API_URL}/OffshoreWork`);

        setStats([
          { name: "Supply", count: supply.data.length },
          { name: "Husbandry", count: husbandry.data.length },
          { name: "Civil", count: civil.data.length },
          { name: "Offshore", count: offshore.data.length }
        ]);
      }
      catch (err) {
        console.error("error", err);
      }
    };
    fetchServeic();
  }, []);

  // Courses Stats
  const [course, setcourse] = useState([]);
  useEffect(() => {
    const fetchServeic = async () => {
      try {
        const Kids = await axios.get(`${API_URL}/kidsCourses`);
        const Adults = await axios.get(`${API_URL}/diveCourses`);

        setcourse([
          { name: "Kids Diving", count: Kids.data.length },
          { name: "Adults Diving", count: Adults.data.length }
        ]);
      }
      catch (err) {
        console.error("error", err);
      }
    };
    fetchServeic();
  }, []);

  const COLORS = ['#06b6d4', '#10b981', '#8b5cf6', '#f59e0b', '#ef4444', '#ec4899'];

  const totalTrips = chatData.reduce((acc, item) => acc + item.count, 0);
  const totalServices = stats.reduce((acc, item) => acc + item.count, 0);
  const totalCourses = course.reduce((acc, item) => acc + item.count, 0);

  return (
    <div className="p-6">
      {/* Header */}
      <div className="bg-white/10 backdrop-blur-xl rounded-2xl p-6 mb-6 border border-white/20">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div>
            <h2 className="text-3xl font-bold text-white flex items-center gap-3">
              <span className="text-4xl">📊</span> Analytics Dashboard
            </h2>
            <p className="text-cyan-200 mt-1">Overview of all business metrics and statistics</p>
          </div>

          <div className="flex flex-wrap gap-3">
            <div className="bg-gradient-to-br from-cyan-500 to-blue-500 rounded-xl px-5 py-3 text-white">
              <p className="text-xs opacity-80">Total Trips</p>
              <p className="text-2xl font-bold">{totalTrips}</p>
            </div>
            <div className="bg-gradient-to-br from-emerald-500 to-teal-500 rounded-xl px-5 py-3 text-white">
              <p className="text-xs opacity-80">Marine Services</p>
              <p className="text-2xl font-bold">{totalServices}</p>
            </div>
            <div className="bg-gradient-to-br from-purple-500 to-pink-500 rounded-xl px-5 py-3 text-white">
              <p className="text-xs opacity-80">Courses</p>
              <p className="text-2xl font-bold">{totalCourses}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Charts Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        
        {/* Trips Chart */}
        <div className="bg-white/10 backdrop-blur-xl rounded-2xl p-6 border border-white/20">
          <h3 className="text-xl font-bold text-white mb-6 flex items-center gap-2">
            <span>🚤</span> Trip Bookings by Destination
          </h3>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={chatData}>
              <XAxis dataKey="name" tick={{ fill: '#94a3b8', fontSize: 12 }} />
              <Tooltip 
                contentStyle={{ 
                  backgroundColor: 'rgba(15, 23, 42, 0.9)', 
                  border: '1px solid rgba(255,255,255,0.1)',
                  borderRadius: '12px',
                  color: '#fff'
                }} 
              />
              <Bar dataKey="count" radius={[8, 8, 0, 0]}>
                {chatData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>

        {/* Services Chart */}
        <div className="bg-white/10 backdrop-blur-xl rounded-2xl p-6 border border-white/20">
          <h3 className="text-xl font-bold text-white mb-6 flex items-center gap-2">
            <span>⚓</span> Marine Services Distribution
          </h3>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={stats}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={100}
                paddingAngle={5}
                dataKey="count"
                label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
              >
                {stats.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip 
                contentStyle={{ 
                  backgroundColor: 'rgba(15, 23, 42, 0.9)', 
                  border: '1px solid rgba(255,255,255,0.1)',
                  borderRadius: '12px',
                  color: '#fff'
                }} 
              />
              <Legend wrapperStyle={{ color: '#94a3b8' }} />
            </PieChart>
          </ResponsiveContainer>
        </div>

        {/* Courses Chart */}
        <div className="bg-white/10 backdrop-blur-xl rounded-2xl p-6 border border-white/20">
          <h3 className="text-xl font-bold text-white mb-6 flex items-center gap-2">
            <span>🎓</span> Diving Course Enrollments
          </h3>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={course} layout="vertical">
              <XAxis type="number" tick={{ fill: '#94a3b8' }} />
              <Tooltip 
                contentStyle={{ 
                  backgroundColor: 'rgba(15, 23, 42, 0.9)', 
                  border: '1px solid rgba(255,255,255,0.1)',
                  borderRadius: '12px',
                  color: '#fff'
                }} 
              />
              <Bar dataKey="count" radius={[0, 8, 8, 0]}>
                {course.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={index === 0 ? '#10b981' : '#06b6d4'} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
          
          {/* Course Stats */}
          <div className="grid grid-cols-2 gap-4 mt-6">
            {course.map((item, index) => (
              <div key={index} className={`rounded-xl p-4 ${index === 0 ? 'bg-emerald-500/20' : 'bg-cyan-500/20'}`}>
                <p className="text-white/70 text-sm">{item.name}</p>
                <p className="text-white text-2xl font-bold">{item.count}</p>
                <p className="text-white/50 text-xs">enrollments</p>
              </div>
            ))}
          </div>
        </div>

        {/* Services Breakdown */}
        <div className="bg-white/10 backdrop-blur-xl rounded-2xl p-6 border border-white/20">
          <h3 className="text-xl font-bold text-white mb-6 flex items-center gap-2">
            <span>📈</span> Services Breakdown
          </h3>
          <ResponsiveContainer width="100%" height={250}>
            <BarChart data={stats}>
              <XAxis dataKey="name" tick={{ fill: '#94a3b8', fontSize: 12 }} />
              <Tooltip 
                contentStyle={{ 
                  backgroundColor: 'rgba(15, 23, 42, 0.9)', 
                  border: '1px solid rgba(255,255,255,0.1)',
                  borderRadius: '12px',
                  color: '#fff'
                }} 
              />
              <Bar dataKey="count" radius={[8, 8, 0, 0]}>
                {stats.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>

          {/* Service Stats Grid */}
          <div className="grid grid-cols-2 gap-3 mt-4">
            {stats.map((item, index) => (
              <div key={index} className="bg-white/5 rounded-lg p-3 flex items-center gap-3">
                <div className="w-3 h-3 rounded-full" style={{ backgroundColor: COLORS[index] }}></div>
                <div>
                  <p className="text-white/70 text-xs">{item.name}</p>
                  <p className="text-white font-bold">{item.count}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Reports;
